module.exports = __webpack_public_path__ + "static/media/angler_fish.12208314.svg";